export default {
  name: 'CBanner',
  props: {
    nobtn: {
      default: false,
      type: Boolean
    },
    white: {
      default: false,
      type: Boolean
    },
    nobg: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      info: {}
    };
  },
  created() {
    this.info = this.$dic.banner[this.$route.name];
  },
  methods: {
    handleGo() {
      this.info.url && window.open(this.info.url);
    }
  }
};